import { Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";

type Props = {
  navigatePath: string,
  i18nKey: string
}

export default function(props: Props) {

  let navigate = useNavigate(); 
  const routeChange = () =>{ 
    let path = props.navigatePath;
    navigate(path, { replace: true });
  }

  return (
    <a className="login-link" onClick={routeChange}>
      <Trans i18nKey={props.i18nKey}></Trans>
    </a>
  );
}